import {easyPieChart} from '../vendor/jquery.easypiechart.min'

$(function () {
    window.initEasyPieChart();
    window.initSlider();

    $(document).on('click', '.js-btn-credit, .js-btn-tradein', function () {
        let $box = $(this).parents('.card-row');

        let $credit = $('.js-btn-credit', $box);
        let creditFlag = $credit.is(':checked');
        let credit = parseInt($credit.data('credit'));

        let $tradein = $('.js-btn-tradein', $box);
        let tradeinFlag = $tradein.is(':checked');
        let tradein = parseInt($tradein.data('tradein'));

        let $goodprice = $('.good-price', $box);
        $goodprice.removeClass('less');

        if(credit || tradein) {
            let switchf = credit > tradein ? creditFlag : tradeinFlag;
            if(!switchf) {
                $goodprice.addClass('less');
            }
        }

        if(creditFlag === false) {
            credit = 0;
        }
        if(tradeinFlag === false) {
            tradein = 0;
        }

        let $newprice = $('.new-price', $box);
        let price = parseInt($newprice.data('old-price'));

        price = prettyNumber(price - credit - tradein);

        $('span',$newprice).text(`${price} ₽`);
    });
});

window.initEasyPieChart = function (parentSelector) {
    parentSelector = parentSelector || '';
    $('.chart', parentSelector).easyPieChart({
        barColor: '#42BA18',
        scaleColor: false,
        lineWidth: 2,
        lineCap: 'circle',
        size: '26',
    });
}

window.initSlider = function (parentSelector) {
    parentSelector = parentSelector || '';
    let $sliderContainers = $('.row-slider:not(.slick-initialized)', parentSelector);
    $sliderContainers.slick();

    $sliderContainers.each(function (i, e) {
        let $slider = $(e);
        $('.slick-arrow', $slider).on('click', function (e) {
            e.preventDefault();
        });

        let $boxImages = $slider.parents('.box-images');
        if ($boxImages.length) {
            $('.tile', $boxImages).on('mouseenter', function () {
                let index = $(this).data('index');
                $slider.slick('slickGoTo', index, true);
            });
            $boxImages.on('mouseleave', function () {
                $slider.slick('slickGoTo', 0, true);
            })
        }
    });

    setTimeout(function () {
        $('.transparent').removeClass('transparent');
    }, 500);
}
